<template>
  <div v-if="!(bookingDate && ticket.isClosed)" class="px-xl-4">
    <div class="py-20 border-bottom-gray " :class="{ 'disabled-ticket-card': isSold }">
      <!-- top row -->
      <div class="req-notification d-lg-none d-block " v-if="isRequested">
        <p @click="openModal" class="f-12 fw-600 mb-0"><img class="icon-info" src="@/assets/icons/icon-information.svg"
            alt="info icon">
          On request</p>

      </div>
      <div v-show="showModal" class="req-modal">
        <div class="text-right">
          <p class="mb-0 f-18" @click="closeModal">close<img class="ml-5 modal-close-icon" src="@/assets/icons/icon-close-circle.svg">
          </p>

        </div>
        <div class="req-notification " v-if="isRequested">

          <p class="f-12 fw-600 mb-0"><img class="icon-info" src="@/assets/icons/icon-information.svg" alt="info icon">
            On request</p>
        </div>
        <p class="mt-10 f-16 mb-0">
          The selected date is on request. Please proceed with your booking and we will confirm the availability to you
          shortly. Note: No payment will be taken upfront until we approve the availability.
        </p>
      </div>
      <div class="row f-sm">
        <div class="col-xxl-7 col-xl-6 col-md-6 col-5">
          <!-- <span v-if="ticket.ticketColor" :style="{ backgroundColor: ticket.ticketColor} " class="br-100 d-inline-block ticket-highlighter mr-5">  </span> -->
          <p class="f-16" @click="toggleDetails">
            <i :class="showDetails ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></i>

            <strong class="ml-5 fw-600">{{ ticket.ticketName }}</strong>
          </p>


        </div>
        <div class="col-xxl-2 col-xl-2 col-md-3  col-4  text-sm-left">
          <div class="row">
            <div class="col-xl-12 text-nowrap f-16 f-sm-14 p-0" :class="ticket.isFree ? 'color-darkgreen' : ''">
              <strong class="fw-400"> {{ ticket.isFree ? 'Free' : (isCustomPrice ? ('Rs ' +
                Number(customPrice).toLocaleString()) : ('Rs ' + Number(ticket.pricePerTicket).toLocaleString()))
                }}</strong>


              <span v-if="!ticket.isFree" class="f-8"> each</span>

             

            </div>
            <div class="col-xl-12 pl-sm-0">
              <div class=" mt-10 d-flex  f-16 f-sm-14">
                <template v-if="isSold">
                  <p class="fw-500">Sold Out</p>
                </template>

                <template v-if="!isSold && selectedTickets && !ticket.isFree">
                  <p class="m-0 fw-700 f-sm-14">Total</p>
                  <strong class="text-nowrap ml-5 fw-500">
                    Rs {{ isCustomPrice ? Number(ticket.customPrice * selectedTickets).toLocaleString() :
                      Number(ticket.pricePerTicket * selectedTickets).toLocaleString() }}
                  </strong>
                </template>
              </div>
              <p v-if="selectedTickets && !ticket.isFree" class="text-black text-nowrap f-12">Earn <span class="text-darkgreen fw-700">{{ calculateRewardPoints(isCustomPrice ? ticket.customPrice * selectedTickets : ticket.pricePerTicket * selectedTickets) }} </span> Reward points </p>

            </div>
          </div>
        </div>
        <div class="col-xxl-3 col-xl-4 col-md-3 col-3 pl-lg-35 paddingleft-md-0 pr-15">
          <div class="row"
            :class="[(!singleEvent.isReservation || bookingDate !== null) ? '' : 'disabled-ticket-card']">
            <div class="col-xl-12 text-right">
              <div class="">


                <div class="ticketcard-select d-flex">
                  <div class="ticketcard-quantity w-50">
                    <p class="mb-0 text-black">Qty</p>
                  </div>
                  <select
                    class="form-control m-0 d-inline-block bg-white wrap f-14 h-48 bdr-top-2 bdr-bottom-2 bdr-right-2 bdr-left-0  w-50"
                    @change="onSelectChange" v-model="selectedTickets"
                    :class="[selectedTickets ? 'bdr-black' : 'bdr-black']">
                    <option v-for="(t, index) in quantityRange" :key="ticket._id + index" :value="t"
                      >
                      {{ t }}
                    </option>
                  </select>
                
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <template v-if="showDetails">
        <div class="row my-2 f-12"></div>
        <div v-html="ticket.description" class="px-10 ticket-details tinymce-editor"></div>
      </template>
    </div>
  </div>


</template>

<script>
import { mapGetters } from 'vuex';
import { SAVE_EVENT_API_BODY } from '../../../store/actions.type';
import localStorageServices from '@/common/jwt.services'
import { calculateRewardPoints } from '../../Events/utils';

export default {
  name: 'TicketCard',
  components: {},
  props: {
    bookingDate: {},
    customPrice: {},
    isRequested: {
      type: Boolean
    },
    isLoading: {
      type: Boolean
    },
    isCustomPrice: {
      type: Boolean
    },
    ticket: {
      type: Object,
      required: true,
    },
    eventByDate: {
      type: Array
    },
    isSparkError: {
      type:Boolean
    },
    selectedQuantities:{
      type: Object
    },
    previousid:{
      type: String
    },
    selectedQuantity:{
      type: Number
    }
  },

  data() {
    return {
      showDetails: false,
      selectedTickets: 0,
      showModal: false,  // Controls the visibility of the modal

    };
  },
  watch: {
    previousid(newVal) {
    if (newVal === this.ticket._id) {
      this.selectedTickets = 0;
    }
  },
  selectedQuantity(newVal){
    if (newVal === null){
      this.selectedTickets = 0;

    }
  }
},
  computed: {
    quantityRange() {
      const {
        totalAllottedQuantity,
        ticketsSold,
        maximumAllowedTickets,
        minimumAllowedTickets
      } = this.ticket;

      const availableQuantity = (totalAllottedQuantity - ticketsSold)
      const maximumQuantity = (availableQuantity > maximumAllowedTickets) ? maximumAllowedTickets : availableQuantity 
        // ? maximumAllowedTickets
        // : totalAllottedQuantity - ticketsSold >

      // Generate an array of numbers from minQuantity to maxQuantity
      const range = Array.from(
        { length: maximumQuantity - minimumAllowedTickets + 1 },
        (_, i) => minimumAllowedTickets + i
      );
      range.unshift(0);
      return range;
    },

    isExpiredTicket() {
      return new Date(this.ticket.endDate).getTime() > new Date().getTime();
    },

    ...mapGetters(['singleEvent']),

    noOfTickets() {
      return +ticket.maximumAllowedTickets + 1;
    },

    isSold() {

      const isTicketIsSold = this.ticket.isClosed ||  (this.ticket.totalAllottedQuantity - (this.ticket.ticketsSold + Math.abs(this.ticket.ticketsOnHold)) < 1);

      if(this.singleEvent.isReservation) {
        return isTicketIsSold && this.bookingDate !== null
      }

      if(!this.singleEvent.isReservation) {
        return isTicketIsSold
      }
  },
  },
  methods: {
    calculateRewardPoints,

    openModal() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    onSelectChange(item) {
      this.$emit('quantity-selected', this.ticket, this.selectedTickets);

    },
    toggleDetails() {
      this.showDetails = !this.showDetails;
    },
  },
};
</script>
<style lang="scss">
.top-align {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 100;
}

.request-btn {
  border: none;
  background-color: #febb02 !important;
  color: #1c1c1c !important;
}

.request-btn:hover {
  border: none !important;

}

.ticketcard-quantity {
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  display: flex !important;
  justify-content: center;
  align-content: center;
  align-items: center;
  border: 1.5px solid;
  width: 50%;
  border-right: 0px solid;
}

.ticketcard-select {
  position: relative;
  display: inline-block;
  color: #555;
  width: 100%;
  height: 48px !important;

  @media (max-width: 1200px) {
    select {
      border-left-width: 2px;
    }
  }
}

.ticket-highlighter {
  width: 14px;
  height: 14px;
}

.ticketcard-select select {
  padding: 0.5em 0.25em 0.5em 1.5em;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  border: 1.5px solid;
}

.ticketcard-select select:focus {
  border-color: #000 !important;
}



.ticketcard-select:after {
  font-weight: 900;
  position: absolute;
  top: 34.9%;
  right: 1.5em;
  font-family: 'Font Awesome 5 free';
  font-display: swap;
  font-size: 12px;
  content: '\f078';
  pointer-events: none;
}

.mv {
  max-width: 98%;
  float: right;
}

.buy-now {
  height: 38px !important;
  padding: 0px !important;
  line-height: 0 !important;
  font-size: 12px !important;
}

.ticket-details>p:last-child {
  margin-bottom: 2px;
}

.h-48 {
  height: 48px !important;
}

.onRequestNotification {
  background-color: #febb02 !important;

  padding: 10px;
  margin-bottom: 10px;
}
.pl-lg-35{
  padding-left: 35px ;
}
@media(max-width:1200px){
  .paddingleft-md-0{
    padding-left: 0px !important;
  }
}
@media(max-width:992px) {

  .ticketcard-select select {
    width: 80px !important;
    border-radius: 10px;
    margin-left: auto !important;
  }

  .req-modal {
    height: 100vh;
    position: fixed;
    top: 55px;
    z-index: 1029;
    background: white;
    left: 0;
    background-color: hsla(0, 0%, 100%, 0.8);
    -webkit-backdrop-filter: blur(6px);
    backdrop-filter: blur(5px);
    padding: 20px
  }

  .ticketcard-quantity {
    display: none !important;
  }

  .req-notification {
    width: fit-content;
    height: 26px;
    font-size: 12px;
    padding: 0px 10px !important;
    display: flex;
    align-items: center;
    justify-content: center;
    align-content: center;
    border-radius: 2px !important;
    background-color: #febb02 !important;
  }

  .req-notification img {
    height: 12px;
    width: 12px;
  }
  .modal-close-icon{
    margin-top: -2px;
    height: 17px;
    width: 17px;
  }
}
@media(max-width:992px){
  .f-sm-14{
font-size: 14px !important;
  }
  .pl-sm-0{
    padding-left: 0px !important;
  }
}
</style>
